import { fromJS } from 'immutable'
import {
  COMPANY_GET_REQUEST,
  COMPANY_GET_SUCCESS,
  COMPANY_GET_FAILURE,
  COMPANY_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case COMPANY_GET_REQUEST:
      return state
        .set('isFetching', true)
    case COMPANY_GET_SUCCESS:
      return state
        .set('company', fromJS(action.payload.company))
        .set('isFetching', false)
    case COMPANY_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case COMPANY_GET_RESET:
      return state
        .delete('company')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/company/company-get-reducer.js